import common from './common';
import header from './header';
import landing from './landing';
import meta from './meta';
import route from './route';
import history from './history';
import upload from './upload';
import waitlist from './waitlist';
import dashboard from './dashboard';
import billing from './billing';
import resultView from './resultView';
import analysis from './analysis';
import blogEntry from './blogEntry';
import blogSearch from './blogSearch';
import landingB from './landingB';
import login from './login';
import legal from './legal';

export default {
  common,
  header,
  landing,
  meta,
  route,
  history,
  upload,
  waitlist,
  dashboard,
  billing,
  resultView,
  analysis,
  blogEntry,
  blogSearch,
  landingB,
  login,
  legal,
};
